import React from 'react';

export const ColumnFilter = ({ filter, setFilter }) => {
  return (
    <input
      className='w-full border-hf h-10 rounded px-2 lg:w-64'
      value={filter || ''}
      onChange={(e) => setFilter(e.target.value)}
      placeholder='Search'
    />
    // </span>
  );
};
